import React, {Component} from 'react';
import Select, { components } from "react-select";
import LeftArrowIcon from "../icons/leftArrowIcon";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        border: '1px solid #d8d8d8',
        borderRadius: '0px',
        boxShadow: '0 1px 3px #d8d8d8 inset',
        '&:hover': {
            border: '1px solid #d8d8d8',
        },
        minHeight: 30,
    }),
    container: (base) => ({...base, minHeight: 30}),
    loadingIndicator: (base) => ({
        ...base
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
        position: 'relative',
        width: '29',
        minHeight: '100%',
        height: '30px',
        backgroundColor: '#f9ed43',
        border: '1px solid #ffd402',
        fontSize: '1em; color: #000',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    clearIndicator: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
    }),
    indicatorsContainer: base => ({
        ...base,
    }),
    indicatorSeparator: base => ({display: 'none'}),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0,
        fontFamily: 'arial, sans-serif',
        color: 'black'
    }),
    menu: (provided, state) => ({...provided, zIndex: 3}),
    option: (base) => ({
        ...base,
        fontFamily: 'arial, sans-serif',
        color: 'black',
        fontSize: '1em; color: #000'
    })
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <div className={'general-icon'}>
                <LeftArrowIcon/>
            </div>
        </components.DropdownIndicator>
    );
};

const valueFromIds = (opts, values) => {
    return values.map(value => {
        return opts.find(o => o.value === value.value);
    })
};

class MultiSelectInput extends Component {

    render() {
        let value = this.props.value;
        if(this.props.isMulti){
            try {
                value = valueFromIds(this.props.options, this.props.value)
            } catch (e) {
                value = []
            }
        }
        return (
            <div className={'form-group'}>
                <div className={this.props.labelClassName}>
                    <label className={'control-label.text-left formGroupSelectInput-label'}>
                        {this.props.label}
                    </label>
                </div>
                <div className={this.props.inputClassName}>
                    <Select
                        isLoading={this.props.isLoading}
                        placeholder={this.props.placeholder}
                        components={{ DropdownIndicator }}
                        styles={customStyles}
                        closeMenuOnSelect={this.props.closeMenuOnSelect}
                        isMulti={this.props.isMulti}
                        value={value}
                        onChange={this.props.handleInputChange}
                        options={this.props.options}
                    />
                </div>
            </div>
        )
    }
};

export default MultiSelectInput;